import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import AssignLicence from "./Components/AssignLicence";
import Customer from "./Components/Customer";
import CustomerAdmin from "./Components/CustomerAdmin";
import Project from "./Components/Project";
import Users from "./Components/Users";
import AllocateLicence from "./Components/AllocateLicence";
import ProjectSummary from "./Components/ProjectSummary";
import {
    Stepper,
    Step,
    StepLabel,
    StepConnector,
    Grid,
    Typography,
} from '@material-ui/core';
import { CustomerServices } from '../../Services/CustomerServices';
import { ProjectServices } from '../../Services/ProjectServices';
import CheckIcon from '@material-ui/icons/Check';
import { useHistory, useParams } from 'react-router';
import { Paths } from 'Routes/routePaths';
import { notify } from 'utils';
import commonStyles from 'theme/commonStyles';

const customerServices = new CustomerServices();
const projectServices = new ProjectServices();

export const useStyle = makeStyles((theme) => ({
    root: {
        border: `8px solid ${theme.palette.common.white}`,
        margin: 16,
        padding: "36px 0 0",
        background: `rgba(255,255,255,0.9)`,
        boxShadow: [
            `0px 16px 26px -10px ${theme.palette.primary.main}99`,
            theme.shadows[15]
        ],
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        [theme.breakpoints.down('sm')]: {
            margin: 8,
            padding: "24px 0 0",
        },
        [theme.breakpoints.down('xs')]: {
            margin: 4,
            padding: "16px 0 0",
        },
    },
    stepper: {
        padding: theme.spacing(3, 2, 2),
        overflow: "auto",
        width: '100%',
        backgroundColor: theme.palette.grey[50],
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    stepConnector: {
        top: 14,
        left: 'calc(-50% + 12px)',
        right: 'calc(50% + 12px)',
        '& .MuiStepConnector-line': {
            borderColor: theme.palette.grey[300],
            borderTopWidth: 2,
        },
    },
    stepConnectorActive: {
        '& .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
        },
    },
    stepConnectorCompleted: {
        '& .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
        },
    },
    stepIcon: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.grey[600],
    },
    stepIconActive: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    stepIconCompleted: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    stepLabel: {
        '& .MuiStepLabel-label': {
            fontSize: '0.75rem',
            fontWeight: 500,
            color: theme.palette.grey[600],
        },
        '& .MuiStepLabel-label.MuiStepLabel-active': {
            color: theme.palette.primary.main,
            fontWeight: 600,
        },
        '& .MuiStepLabel-label.MuiStepLabel-completed': {
            color: theme.palette.primary.main,
        },
    },
    stepClickable: {
        cursor: 'pointer',
    },
    navigation: {
        width: 110,
        fontSize: 12,
        [theme.breakpoints.down("xs")]: {
            fontSize: 10,
            width: 90
        }
    },
    prevBtn: {
        color: theme.palette.grey[700],
        background: theme.palette.common.white,
        boxShadow: theme.shadows[5]
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            '& button': {
                flex: '0 0 auto',
                minWidth: 120
            },
        },
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(2),
        borderRadius: '5px',
        minWidth: 120,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    cancelBtn: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        background: '#B7B7B7',
        color: 'white',
        borderRadius: '5px',
        "&:hover": {
            background: "#454343"
        },
        minWidth: 120,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: theme.spacing(1),
        },
    },
    formGrid: {
        [theme.breakpoints.down('sm')]: {
            padding: '12px !important',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '8px !important',
        },
    },
    pageWrapper: {
        maxWidth: '100%',
        overflowX: 'hidden',
        boxSizing: 'border-box',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
}));

const RenderStepContent = ({
    step,
    handleNext,
    handleBack,
    countryList,
    apprenticeshipList,
    coursesList,
    handleUpdateBackupFormData,
    formBackupState,
    assessmentList,
    handleEditTab,
    labsList,
    talentDialogOpen,
    setTalentDialogOpen
}) => {

    switch (step) {
        case 0:
            return <Customer
                handleNext={handleNext}
                countryList={countryList}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.customer}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
                talentDialogOpen={talentDialogOpen}
                setTalentDialogOpen={setTalentDialogOpen}
            />;
        case 1:
            return <AssignLicence
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                apprenticeshipList={apprenticeshipList}
                coursesList={coursesList}
                labsList={labsList}
                assessmentList={assessmentList}
                formBackupState={formBackupState.assignLicence}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 2:
            return <CustomerAdmin
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.customerAdmin}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 3:
            return <Project
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.project}
            />;
        case 4:
            return <Users
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.user}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 5:
            return <AllocateLicence
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.allocateLicenses}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 6:
            return <ProjectSummary
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                handleEditTab={handleEditTab}
            />;
        default:
            return null;
    }
}

const tabs = ["Company", "Assign Licence", "Customer Admin", "Projects", "Users", "Allocate Licenses", "Project Summary"];

const CustomerOnBoarding = () => {

    const classes = useStyle();
    const commonClasses = commonStyles();
    const { id: uuid } = useParams();
    const history = useHistory()

    const [countryList, setCountryList] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [apprenticeshipList, setApprenticeshipList] = useState([]);
    const [assessmentList, setAssessmentList] = useState([]);
    const [coursesList, setCoursesList] = useState([]);
    const [labsList, setLabsList] = useState([]);
    const [formBackupState, setFormBackupState] = useState({
        customer: null,
        assignLicence: null,
        customerAdmin: null,
        project: null,
        user: null,
        allocateLicenses: null,
        projectSummery: null
    });
    const [talentDialogOpen, setTalentDialogOpen] = useState(false);

    React.useEffect(() => {
        getCounties();
        getAssignLicenceDropdown();
        clearLocalStorageItem();
        if (uuid) {
            localStorage.setItem('editstep', 0);
            localStorage.setItem('getAllCustomer', true);
        }
    }, []);

    const handleEditTab = (action) => {
        if (action === 'project') {
            localStorage.setItem('editstep', 3);
            localStorage.setItem('project_edit', true);
            setActiveStep(3);
        } else {
            localStorage.setItem('editstep', 4);
            setActiveStep(4);
        }
    }

    const getCounties = async () => {
        const countries = await customerServices.getCounties();
        setCountryList(countries.country_list);
    }

    const clearLocalStorageItem = () => {
        localStorage.removeItem('editstep');
        localStorage.removeItem('assign_lecense');
        localStorage.removeItem('refreshlic');
        localStorage.removeItem('cstmsrSaveFlow');
        localStorage.removeItem('customerUUID');
        localStorage.removeItem('getAllCustomer');
        localStorage.removeItem('created_user_id');
    }

    const getAssignLicenceDropdown = async () => {
        const apprenticeshipResult = await projectServices.getApprenticeshipsList();
        if (apprenticeshipResult && apprenticeshipResult.data) {
            setApprenticeshipList(apprenticeshipResult.data);
        }
        const assesmentResult = await projectServices.getAssessmentsList();
        if (assesmentResult && assesmentResult.data) {
            const validAss = ["Digital Readiness Assessment", "GC Index", "Work Readiness", "Digital Talent Maturity Model", "AI Maturity Model"];
            setAssessmentList(assesmentResult.data ? assesmentResult.data.filter(ass => validAss.includes(ass.name)) : []);
        }
        // On flowcustomer page (when uuid is present), course dropdown is populated from assign_customer_license response in AssignLicence tab
        if (!uuid) {
            const courseRes = await projectServices.getCoursesList();
            if (courseRes && courseRes.data) {
                setCoursesList(courseRes.data.map((course) => {
                    let courseName = (course.provider === "Xpert Skills") ? `${course.course} - ${course.provider}` : course.course;
                    return { id: course.uuid, name: courseName };
                }));
            }
        }
        const labsRes = await projectServices.getLabsList(null, '?limit=10000');
        if (labsRes && labsRes.results) {
            setLabsList(labsRes.results.map((lab) => {
                return { id: lab.uuid, name: lab.name };
            }));
        }
    };

    const isLastStep = activeStep === tabs.length - 1;

    const handleBack = () => {
        setActiveStep(activeStep - 1);
        localStorage.setItem('editstep', activeStep - 1);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isLastStep) {
            setActiveStep(activeStep + 1);
            return null;
        } else {
            notify("success", `Customer ${(uuid) ? 'updated' : 'created'} Successfully`)
            history.push(Paths.Customers);
        }
    };

    const handleUpdateBackupFormData = (formData, action) => {
        setFormBackupState({ ...formBackupState, [action]: formData });
    }

    const canGoToStep = (index) => index < 4 && uuid;
    const handleStepClick = (index) => {
        if (canGoToStep(index)) setActiveStep(index);
    };

    const StepIcon = ({ active, completed, icon }) => {
        const iconClasses = [
            classes.stepIcon,
            active && classes.stepIconActive,
            completed && classes.stepIconCompleted,
        ].filter(Boolean).join(' ');
        return (
            <div className={iconClasses}>
                {completed ? <CheckIcon style={{ fontSize: 16 }} /> : icon}
            </div>
        );
    };

    return (
        <Layout>
            <main>
                <div className={`${commonClasses.contentWrapper} ${classes.pageWrapper}`} style={{ padding: 0 }}>
                    {!talentDialogOpen && (
                        <Stepper
                            activeStep={activeStep}
                            className={classes.stepper}
                            alternativeLabel
                            connector={
                                <StepConnector
                                    classes={{
                                        root: classes.stepConnector,
                                        active: classes.stepConnectorActive,
                                        completed: classes.stepConnectorCompleted,
                                    }}
                                />
                            }
                        >
                            {tabs.map((label, index) => (
                                <Step
                                    key={label}
                                    completed={activeStep > index}
                                    onClick={() => handleStepClick(index)}
                                    className={canGoToStep(index) ? classes.stepClickable : ''}
                                >
                                    <StepLabel
                                        StepIconComponent={StepIcon}
                                        StepIconProps={{ icon: index + 1 }}
                                        classes={{ root: classes.stepLabel }}
                                    >
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    )}
                    <Grid style={{ padding: 20 }} className={classes.formGrid}>
                        <form onSubmit={handleSubmit}>
                            <RenderStepContent
                                step={activeStep}
                                handleNext={handleSubmit}
                                countryList={countryList}
                                handleBack={handleBack}
                                apprenticeshipList={apprenticeshipList}
                                coursesList={coursesList}
                                assessmentList={assessmentList}
                                formBackupState={formBackupState}
                                handleUpdateBackupFormData={handleUpdateBackupFormData}
                                handleEditTab={handleEditTab}
                                labsList={labsList}
                                talentDialogOpen={talentDialogOpen}
                                setTalentDialogOpen={setTalentDialogOpen}
                            />
                        </form>
                    </Grid>
                </div>
            </main>
        </Layout>
    );
}

export default CustomerOnBoarding;